import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  open(event) {
    if (event?.target?.closest("a, button, input, select, textarea")) return

    window.location.assign(this.urlValue)
  }

  openWithKeyboard(event) {
    if (!["Enter", " "].includes(event.key)) return

    event.preventDefault()
    this.open()
  }
}
